import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
export const TextAreaSkeleton = (props) => {
    return (React.createElement("div", null,
        React.createElement(SkeletonShape, { variant: "rectangular", width: "100%", height: "170px" }),
        props.hint && (React.createElement(SkeletonShape, { spaceStackStart: "s", variant: "rectangular", width: "200px", height: "20px" }))));
};
//# sourceMappingURL=TextArea.skeleton.mjs.mjs.map